import ActiveLog from "@/components/molecules/ActiveLog";
import useLogStore from '@/store/logStore';

const AddLogTickets = ({ticket, logCategories, users}: any) => {
    const { log } = useLogStore();
    return (
    <div className="w-full">
      {log && log.ticket_id !== ticket?.id ? (
        <div className="w-full p-4 rounded-lg shadow-lg">
          <div className="flex w-full flex-col sm:flex-row">
            <div className="text-sm font-semibold">
              You already have an active log for another ticket. Please stop that log before starting a new one.
            </div>
          </div>
        </div>
        
      ) : (
        <ActiveLog
          ticket={{
            id: ticket?.id,
            displayId: ticket?.display_id,
            subject: ticket?.subject,
          }}
          logCategories={logCategories}
          internalSubTicketTypes={
            ticket.internal_ticket_types
              .filter((item: any) =>
                item.internal_sub_ticket_type !== undefined &&
                item.internal_sub_ticket_type.id !== undefined &&
                item.internal_sub_ticket_type.name !== undefined
              )
              .map((item: any) => ({
                id: item.internal_sub_ticket_type!.id,
                name: item.internal_sub_ticket_type!.name,
                internal_ticket_type_id: item.internal_ticket_type.id,
              }))
          }
          users={users}
        />
      )}
    </div>)
  }

  export default AddLogTickets;